<div [class]="model.renderCssRoot" #contentElement>
  <sv-ng-dropdown [model]="model"></sv-ng-dropdown>
  <div *ngIf="model.isShowingChoiceComment" [class]="model.getCommentAreaCss(true)" [question]="model" [item]="model.selectedItem" sv-ng-comment-choice></div>
</div>